var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.828125 2.66431C0.828125 1.71481 1.61712 0.945312 2.59062 0.945312H23.0656C24.0391 0.945312 24.8281 1.71481 24.8281 2.66431V23.2263C24.8281 24.1758 24.0391 24.9453 23.0656 24.9453H2.59062C1.61712 24.9453 0.828125 24.1758 0.828125 23.2263V2.66431ZM8.24262 21.0363V10.1988H4.64113V21.0363H8.24262ZM6.44263 8.71831C7.69812 8.71831 8.47962 7.88731 8.47962 6.84631C8.45712 5.78281 7.69963 4.97431 6.46663 4.97431C5.23362 4.97431 4.42813 5.78431 4.42813 6.84631C4.42813 7.88731 5.20963 8.71831 6.41862 8.71831H6.44263ZM13.8046 21.0363V14.9838C13.8046 14.6598 13.8286 14.3358 13.9246 14.1048C14.1841 13.4583 14.7766 12.7878 15.7726 12.7878C17.0761 12.7878 17.5966 13.7808 17.5966 15.2388V21.0363H21.1981V14.8203C21.1981 11.4903 19.4221 9.94231 17.0521 9.94231C15.1411 9.94231 14.2846 10.9923 13.8046 11.7318V11.7693H13.7806C13.7886 11.7568 13.7966 11.7443 13.8046 11.7318V10.1988H10.2046C10.2496 11.2158 10.2046 21.0363 10.2046 21.0363H13.8046Z",
    fill: "#304050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ff433320aa2a093a9648a20473aa3ff6.svg";
export { ForwardRef as ReactComponent };